import { render, staticRenderFns } from "./TimeLimitSettings.vue?vue&type=template&id=78be0f18&scoped=true"
import script from "./TimeLimitSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./TimeLimitSettings.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TimeLimitSettings.vue?vue&type=style&index=0&id=78be0f18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78be0f18",
  null
  
)

export default component.exports